import { useCallback, useMemo } from 'react';
import { queryFilter, useQueryFilters } from './useQueryFilters';

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50] as const;

export function usePageSize(
  _storageKey: string,
  defaultSize: number = 10,
  options: readonly number[] = PAGE_SIZE_OPTIONS,
) {
  const schema = useMemo(() => ({
    page: queryFilter.integer(1, { min: 1 }),
    pageSize: queryFilter.integer(defaultSize, { allowed: options }),
  }), [defaultSize, options]);
  const { filters, setFilter } = useQueryFilters(schema, { pageKey: 'page' });

  const handlePageSizeChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = parseInt(e.target.value, 10);
      setFilter('pageSize', value);
    },
    [setFilter],
  );

  const handlePageChange = useCallback((page: number) => {
    setFilter('page', page, { resetPage: false });
  }, [setFilter]);

  return {
    page: filters.page,
    pageSize: filters.pageSize,
    pageSizeOptions: options,
    handlePageChange,
    handlePageSizeChange,
  } as const;
}
